import { useCallback } from "react";
import logger from "../services/Logger";

/**
 * Hook for downloading content as a file.
 * @param {object} options
 * @param {string} options.caller - component name for error logging
 * @returns {{ downloadFile: (content: string, filename: string, mimeType: string) => void }}
 */
const useDownloadFile = ({ caller = "Unknown" } = {}) => {
  const downloadFile = useCallback((content, filename, mimeType) => {
    try {
      const blob = new Blob([content], { type: mimeType });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      logger.error(caller, "Failed to download file", { error: err.message });
    }
  }, [caller]);

  return { downloadFile };
};

export default useDownloadFile;
